import { TranslocoService } from '@jsverse/transloco';
import * as urlTemplate from 'url-template';
import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';

import { isNullOrUndefined } from '@app/util/util';
import { mapAutoCarInfo } from '@autos/auto-results/mappers/auto-info.mapper';
import { DateTransformPipe } from '@app/pipes/date-format.pipe';
import { AutoInfo } from '@autos/auto-results/entities/auto-info';
import { autoApi } from '@autos/auto.api';
import { VehicleOption } from '@autos/entities/vehicle';

@Component({
  selector: 'app-auto-segment-detail',
  templateUrl: './auto-segment-detail.component.html',
  styleUrls: ['./auto-segment-detail.component.sass'],
  encapsulation: ViewEncapsulation.ShadowDom,
  standalone: false
})
export class AutoSegmentDetailComponent {

  @Input() autoReservation: VehicleOption;
  @Input() companyCode: string;

  @Output() showAutoDetail: EventEmitter<VehicleOption> = new EventEmitter<VehicleOption>();

  private readonly DATE_FORMAT: string = 'E, d MMM yyyy';
  private readonly TIME_FORMAT: string = 'HH:mm';

  constructor(
    private datePipe: DatePipe,
    private dateTransformPipe: DateTransformPipe,
    public translateService: TranslocoService) {
  }

  get model(): string {
    if (!isNullOrUndefined(this.autoReservation.Vehicle?.Model)) {
      return this.autoReservation.Vehicle.Model;
    }
  }

  get pickUp(): string {
    if (!isNullOrUndefined(this.autoReservation.PickUp?.Time)) {
      return this.formatDate(new Date(this.autoReservation.PickUp.Time));
    }
  }

  get pickUpTime(): string {
    if (!isNullOrUndefined(this.autoReservation.PickUp?.Time)) {
      return this.datePipe.transform(new Date(this.autoReservation.PickUp.Time), this.TIME_FORMAT);
    }
  }

  get dropOff(): string {
    if (!isNullOrUndefined(this.autoReservation.DropOff?.Time)) {
      return this.formatDate(new Date(this.autoReservation.DropOff.Time));
    }
  }

  get dropOffTime(): string {
    if (!isNullOrUndefined(this.autoReservation.DropOff?.Time)) {
      return this.datePipe.transform(new Date(this.autoReservation.DropOff.Time), this.TIME_FORMAT);
    }
  }

  get pickUpPlace(): string {
    return this.autoReservation.PickUp?.Address || '';
  }

  get dropOffPlace(): string {
    return this.autoReservation.DropOff?.Address || '';
  }

  get info(): AutoInfo {
    return mapAutoCarInfo(this.autoReservation);
  }

  get logo_url(): string {
    const url = urlTemplate.parse(autoApi.auto_images).expand({
      provider: `${this.companyCode.toUpperCase()}`
    });
    return url;
  }

  private formatDate(date: Date): string {
    return this.formatStringDate(this.datePipe.transform(date, this.DATE_FORMAT));
  }

  private formatStringDate(date: string): string {
    return this.dateTransformPipe.transform(date);
  }

  public emitOpenDetail(): void {
    this.showAutoDetail.emit(this.autoReservation);
  }
}
